import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SESSION_FEEDBACK, SESSION_FEEDBACK_SUCCESS, SESSION_FEEDBACK_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSessionFeedback({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/get-customer-session`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SESSION_FEEDBACK_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SESSION_FEEDBACK_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SESSION_FEEDBACK_ERROR, payload: error });
  }
}

export function* watchSessionFeedback() {
  yield takeEvery(SESSION_FEEDBACK, getSessionFeedback);
}

function* watchSessionFeedbackSaga() {
  yield all([fork(watchSessionFeedback)]);
}

export default watchSessionFeedbackSaga;
